import React from 'react';

import { withErrorBoundary } from '../../errors';
import { LineChartOptions, LineChartDatum } from '../LineChart';
import { SeriesLegendProps } from '../SeriesLegend/SeriesLegend';

import { formatItems } from '@/views/containers/comparison/Charts/utils/drawdown-chart-helpers';
import { ROLLING_INTERVALS } from '@/utils/portfolios';
import ComparisonItem from '@/types/comparison-item';
import Nullable from '@/types/nullable';
import Dictionary from '@/types/dictionary';
import Fund from '@/types/fund';
import Stock from '@/types/stock';
import LocalCurrency from '@/types/local-currency';
import AppRegion from '@/types/app-region';
import { TIME_PERIODS } from '@/utils/constants';
import DrawdownAnalysisChart from './DrawdownAnalysisChart';

type Props = {
  appRegion: AppRegion;
  chartOptions: LineChartOptions;
  customDisclaimer?: boolean;
  dark?: boolean;
  detailedDisclaimer?: boolean;
  emptyStateText?: string;
  endDate: Date;
  expandedPortfoliosData?: Dictionary<{ funds: Dictionary<Fund>; stocks: Dictionary<Stock> }>;
  fillArea?: boolean;
  interval: ROLLING_INTERVALS;
  items: ComparisonItem[];
  localCurrency: LocalCurrency;
  seriesLegendProps?: SeriesLegendProps;
  shortHistory?: boolean;
  showBaseCurrencies?: boolean;
  startDate: Nullable<Date>;
  useMonthly: boolean;
  dateQuickRange?: Nullable<TIME_PERIODS>;
};

const DrawdownAnalysis: React.FC<Props> = ({
  appRegion,
  chartOptions,
  customDisclaimer,
  dark,
  detailedDisclaimer,
  emptyStateText,
  endDate,
  expandedPortfoliosData,
  fillArea,
  interval,
  items,
  localCurrency,
  seriesLegendProps,
  shortHistory,
  showBaseCurrencies,
  startDate,
  useMonthly,
  dateQuickRange,
}) => {
  const data: LineChartDatum[] = formatItems({
    items,
    expandedPortfoliosData,
    fillArea,
    showBaseCurrencies,
    shortHistory,
    localCurrency,
    appRegion,
    startDate,
    endDate,
    useMonthly,
  });

  return (
    <DrawdownAnalysisChart
      data={data}
      chartOptions={chartOptions}
      customDisclaimer={customDisclaimer}
      dark={dark}
      detailedDisclaimer={detailedDisclaimer}
      emptyStateText={emptyStateText}
      interval={interval}
      items={items}
      seriesLegendProps={seriesLegendProps}
      shortHistory={shortHistory}
      startDate={startDate}
      endDate={endDate}
      dateQuickRange={dateQuickRange}
    />
  );
};

export default withErrorBoundary(DrawdownAnalysis);
